
import Vue from 'vue';
import BravadoProgressChartV2 from '~/components/common/BravadoProgressChartV2/BravadoProgressChartV2.vue';

const colorsMap = new Map([
  ['gray', 'var(--gray-50)'],
  ['card', 'var(--theme-color-card)'],
  ['white', 'var(--white)'],
]);

const sizesMap = new Map([
  ['md', 24],
  ['lg', 32],
]);

export default Vue.extend({
  name: 'BravadoSpinnerV2',
  components: { BravadoProgressChartV2 },
  props: {
    size: {
      type: String,
      default: 'lg',
      validator: (value: string) => sizesMap.has(value),
    },
    variant: {
      type: String,
      default: 'gray',
      validator: (value: string) => colorsMap.has(value),
    },
  },
  computed: {
    bgColor() {
      return colorsMap.get(this.variant) || 'var(--gray-50)';
    },
    spinnerSize() {
      return sizesMap.get(this.size) || 24;
    },
  },
});
